import Swal from 'sweetalert2'

    ;

jQuery(document).ready(function ($) {
    "use strict";

    // Platform Detection
    const IOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream,
        Android = navigator.userAgent.toLowerCase().indexOf("android") > -1,
        Firefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1,
        Edge = navigator.userAgent.toLowerCase().indexOf('edge') > -1,
        IE = navigator.userAgent.toLowerCase().indexOf('msie ') > -1;

    // Browser Windows Sizes
    const browser = {
        w: document.documentElement.clientWidth,
        h: document.documentElement.clientHeight,
    };

    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    $(window).on('resize orientationchange', () => {
        browser.w = document.documentElement.clientWidth;
        browser.h = document.documentElement.clientHeight;

        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    });

    /* ----------------------------------- Scrollbar CSS Variable ------------------------------------ */
    {
        function getScrollbarWidth() {

            // Creating invisible container
            const outer = document.createElement('div');
            outer.style.visibility = 'hidden';
            outer.style.overflow = 'scroll'; // forcing scrollbar to appear
            outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
            document.body.appendChild(outer);

            // Creating inner element and placing it in the container
            const inner = document.createElement('div');
            outer.appendChild(inner);

            // Calculating difference between container's full width and the child width
            const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);

            // Removing temporary elements from the DOM
            outer.parentNode.removeChild(outer);

            return scrollbarWidth;

        }

        if ($('body').outerHeight() <= document.documentElement.clientHeight) {
            document.documentElement.style.setProperty('--scroll-width', 0);
        } else {
            document.documentElement.style.setProperty('--scroll-width', getScrollbarWidth() + 'px');
        }
    }

    /* ----------------------------------- Cart Page ------------------------------------ */
    {
        // Updating of cart
        $('body').on('wc_fragments_refreshed wc_fragments_ajax_error  wc_fragment_refresh  wc_fragments_loaded ', function () {
            document.querySelectorAll('.counter').forEach((el) => {
                App.$initComponents(el);
                App.$initDirectives(el)
            });
        });
    }

    /* ----------------------------------- Attribute Filter ------------------------------------ */
    {
        let click = true;
        $('.filter__item-row ').on('click', function (e) {
            if (!click) {
                e.preventDefault();
            } else {
                click = false;
                location.href = $(this).attr('href');
            }
        });

        $('.spoiler').each(function () {
            const item = $(this);
            const button = $(this).find('.spoiler-button');
            const content = $(this).find('.spoiler-content');
            button.on('click', function (e) {
                item.toggleClass('_active');
                content.slideToggle('fast');
            });
        });
    }

    /* ----------------------------------- Products Load More ------------------------------------ */
    {
        $('.products-load-more').click(function () {
            var button = $(this),
                data = {
                    'action': 'products_loadmore',
                    'nonce_code': PHP.products_loadmore_nonce,
                    'query': PHP.posts,
                    'page': PHP.current_page
                };
            $.ajax({
                url: PHP.ajaxurl,
                data: data,
                type: 'POST',
                beforeSend: function (xhr) {
                    $('body').addClass('wait');
                    button.attr('disabled', true);
                },
                success: function (data) {
                    if (data) {
                        button.attr('disabled', false);
                        $(data).appendTo('.catalog__list').hide().fadeIn('fast');

                        PHP.current_page++;
                        if (PHP.current_page == PHP.max_page) {
                            button.remove();
                        }
                    } else {
                        button.remove();
                        $('.catalog__pagination').remove();
                    }
                    $('body').removeClass('wait');
                }
            });
        });

    }

    /* ----------------------------------- Contact Form ------------------------------------ */
    {
        $('.contact__form').on('submit', function (e) {
            e.preventDefault();

            const form = $(this);
            let data = new FormData();

            // Ajax Settings
            data.append('nonce_code', PHP.contact_page_form);
            data.append('action', 'contact_page_form');

            // Info
            data.append('name', form.find('input[name=name]').val());
            data.append('address', form.find('input[name=address]').val());
            data.append('postcode', form.find('input[name=postcode]').val());
            data.append('phone', form.find('input[name="phone"]').val());
            data.append('email', form.find('input[name=email]').val());
            data.append('subject', form.find('input[name=subject]').val());
            data.append('message', form.find('textarea[name=message]').val());

            $.ajax({
                url: PHP.ajaxurl,
                data: data,
                type: 'POST',
                cache: false,
                dataType: 'json',
                processData: false,
                contentType: false,
                beforeSend: function (xhr) {
                    form.find('button[type=submit]').attr('disabled', true);
                    $('body').addClass('wait loading');
                },
                complete: function (response) {

                    if (response.responseJSON.admin_email == 'success') {
                        Swal.fire({
                            icon: 'success',
                            title: PHP.form_success.title,
                            text: PHP.form_success.text,
                            confirmButtonText: PHP.form_success.btn_text
                        });
                        form.trigger('reset');
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: PHP.form_error.title,
                            text: PHP.form_error.text,
                            confirmButtonText: PHP.form_error.btn_text
                        });
                    }

                    setTimeout(() => {
                        form.find('button[type=submit]').attr('disabled', false);
                        $('body').removeClass('wait loading');
                    }, 150);
                }
            });


        });
    }

    /* ----------------------------------- Ship to different address checkbox ------------------------------------ */
    {
        $("#ship-to-different-address label").on('click', function (e) {
            e.preventDefault();
            if ($('#ship-to-different-address-checkbox').prop("checked")) {
                $('.page-checkout .shipping_address').slideUp('fast');
                $('#ship-to-different-address-checkbox').prop("checked", false);
            } else {
                $('.page-checkout .shipping_address').slideDown('fast');
                $('#ship-to-different-address-checkbox').prop("checked", true);
            }
        });
    }

});

/* ----------------------------------- Animation ------------------------------------ */
jQuery(window).load(function () {
    jQuery(".cover__content").addClass(
        "animate__animated animate__bounceInDown"
    );
});
